<template>
  <!-- 领券中心页面 -->
  <div class="couponPage">
    <!-- 优惠券列表 -->
    <section class="listWrap">
      <van-divider v-if="!productData.length && !productLoading" dashed :style="{ color: '#999', borderColor: '#f5f5f5', padding: '0 16px' }"
        >很遗憾，没有优惠券数据</van-divider
      >
      <van-loading v-if="!isPaging && productLoading" size="24px" vertical>数据加载中...</van-loading>
      <van-list
        v-if="isPaging"
        v-model:loading="productLoading"
        :finished="productFinished"
        :finished-text="productData.length ? '没有更多了' : ''"
        @load="getProductData"
        offset="450"
      >
        <template v-for="item in productData" :key="item.id">
          <couponCard class="couponCard" :datas="item" @click="toDetail(item)">
            <couponBtn :data="item.cardBtn" @click="clickBtn($event, item)" />
          </couponCard>
        </template>
      </van-list>
      <div v-if="!isPaging">
        <template v-for="item in productData" :key="item.id">
          <couponCard class="couponCard" :datas="item" @click="toDetail(item)">
            <couponBtn :data="item.cardBtn" @click="clickBtn($event, item)" />
          </couponCard>
        </template>
      </div>
      <van-divider v-if="!isPaging && productData.length && !productLoading" dashed :style="{ color: '#999', borderColor: '#f5f5f5', padding: '0 16px' }"
        >没有更多了</van-divider
      >
    </section>
    <!-- 底部按钮 -->
    <section class="bottomWrap">
      <couponBtn :data="bottomBtnData" @click="toMyCouponList"> <van-icon name="coupon-o" size="26" /><span>我的优惠券</span> </couponBtn>
    </section>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import couponCard from '@/components/couponCollection/CouponCard'
import couponBtn from '@/components/order/BottomBtn'
import { getCouponCollectionList } from '@/api/couponCollection'
import { reorganizeListData, showToast } from '@/util/couponCollection'

export default {
  name: 'couponPage',
  components: {
    couponCard,
    couponBtn
  },
  setup() {
    let router = useRouter()
    let state = reactive({
      productData: [], // 产品数据
      productLoading: false,
      productCanLoad: true,
      productFinished: false,
      productPageNo: 1,
      pageSize: 10000,
      bottomBtnData: [{ type: 'plain', size: 'large', path: '/myCouponList' }],
      isPaging: false
    })

    // 获取产品数据
    const getProductData = async () => {
      // 防止反复加载，不要删
      if (!state.productCanLoad) return
      state.productCanLoad = false
      try {
        state.productLoading = true
        let { list: CouponCollectionData = [], pagination = {} } = await getCouponCollectionList({
          pageNo: state.productPageNo,
          pageSize: state.pageSize
        })
        // 数据格式化
        let list = reorganizeListData(CouponCollectionData)
        // console.log("CouponCollectionList-->", list);
        const res = list ? list : []
        state.productFinished = pagination.pageNo === pagination.pageCount
        state.productData = state.productData.concat(res)
        state.productLoading = false
        state.productCanLoad = true
        state.productPageNo += pagination.pageNo < pagination.pageCount ? 1 : 0
      } catch (e) {
        showToast(e.message, '请求产品列表数据失败')
        state.productLoading = false
        state.productCanLoad = false
        state.productFinished = true
      }
    }
    // 跳转详情
    const toDetail = item => {
      router.push({
        path: '/couponDetail',
        query: { from: 'couponList', couponId: item.id, event: '查看卡券详情' }
      })
    }
    // 点击按钮函数
    let clickBtn = (v, data) => {
      toDetail({ v, ...data })
    }
    // 跳转到我的优惠券
    let toMyCouponList = ({ path }) => {
      router.push({ path, query: { event: '我的优惠券列表' } })
    }

    onMounted(() => {
      // getProductData();
      !state.isPaging && getProductData()
    })

    return {
      ...toRefs(state),
      getProductData,
      toDetail,
      clickBtn,
      toMyCouponList
    }
  }
}
</script>

<style lang="scss" scoped>
.couponPage {
  height: 100%;
  overflow-y: auto;
  padding: 16px;
  background-color: #f5f5f5;
  color: #666666;
  font-size: 12px;
  box-sizing: border-box;
}

.listWrap {
  padding-bottom: 135px;
}
.bottomWrap {
  position: fixed;
  bottom: 50px;
  left: 0;
  right: 0;
  // padding: 16px 20px 50px;
  background-color: #f5f5f5;
  .van-badge__wrapper {
    margin-right: 10px;
    vertical-align: middle;
  }
  .span {
    vertical-align: middle;
  }
  padding-top: 16px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: calc(16px + constant(safe-area-inset-bottom));
  padding-bottom: calc(16px + env(safe-area-inset-bottom));
}
.couponCard {
  margin-bottom: 12px;
}
</style>
